package com.tovtalk.database

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String

public class PostQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getPostById(id: Long, mapper: (
    id: Long,
    postType: Long,
    userId: Long,
    description: String?,
    hashtags: String?,
    video: String?,
    thumbnail: String?,
    images: String?,
    views: Long,
    likes: Long,
    comments: Long,
    saves: Long,
    shares: Long,
    isLiked: Long,
    isSaved: Long,
    isPinned: Long,
    canComment: Long,
    isTrending: Long,
    placeTitle: String?,
    placeLat: Double?,
    placeLon: Double?,
    state: String?,
    country: String?,
    musicId: Long?,
    createdAt: String,
    updatedAt: String,
  ) -> T): Query<T> = GetPostByIdQuery(id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getString(18),
      cursor.getDouble(19),
      cursor.getDouble(20),
      cursor.getString(21),
      cursor.getString(22),
      cursor.getLong(23),
      cursor.getString(24)!!,
      cursor.getString(25)!!
    )
  }

  public fun getPostById(id: Long): Query<PostEntity> = getPostById(id) { id_, postType, userId,
      description, hashtags, video, thumbnail, images, views, likes, comments, saves, shares,
      isLiked, isSaved, isPinned, canComment, isTrending, placeTitle, placeLat, placeLon, state,
      country, musicId, createdAt, updatedAt ->
    PostEntity(
      id_,
      postType,
      userId,
      description,
      hashtags,
      video,
      thumbnail,
      images,
      views,
      likes,
      comments,
      saves,
      shares,
      isLiked,
      isSaved,
      isPinned,
      canComment,
      isTrending,
      placeTitle,
      placeLat,
      placeLon,
      state,
      country,
      musicId,
      createdAt,
      updatedAt
    )
  }

  public fun <T : Any> getPostsByType(
    postType: Long,
    `value`: Long,
    mapper: (
      id: Long,
      postType: Long,
      userId: Long,
      description: String?,
      hashtags: String?,
      video: String?,
      thumbnail: String?,
      images: String?,
      views: Long,
      likes: Long,
      comments: Long,
      saves: Long,
      shares: Long,
      isLiked: Long,
      isSaved: Long,
      isPinned: Long,
      canComment: Long,
      isTrending: Long,
      placeTitle: String?,
      placeLat: Double?,
      placeLon: Double?,
      state: String?,
      country: String?,
      musicId: Long?,
      createdAt: String,
      updatedAt: String,
    ) -> T,
  ): Query<T> = GetPostsByTypeQuery(postType, value) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getString(18),
      cursor.getDouble(19),
      cursor.getDouble(20),
      cursor.getString(21),
      cursor.getString(22),
      cursor.getLong(23),
      cursor.getString(24)!!,
      cursor.getString(25)!!
    )
  }

  public fun getPostsByType(postType: Long, value_: Long): Query<PostEntity> =
      getPostsByType(postType, value_) { id, postType_, userId, description, hashtags, video,
      thumbnail, images, views, likes, comments, saves, shares, isLiked, isSaved, isPinned,
      canComment, isTrending, placeTitle, placeLat, placeLon, state, country, musicId, createdAt,
      updatedAt ->
    PostEntity(
      id,
      postType_,
      userId,
      description,
      hashtags,
      video,
      thumbnail,
      images,
      views,
      likes,
      comments,
      saves,
      shares,
      isLiked,
      isSaved,
      isPinned,
      canComment,
      isTrending,
      placeTitle,
      placeLat,
      placeLon,
      state,
      country,
      musicId,
      createdAt,
      updatedAt
    )
  }

  public fun <T : Any> getUserPosts(
    userId: Long,
    postType: Long,
    `value`: Long,
    mapper: (
      id: Long,
      postType: Long,
      userId: Long,
      description: String?,
      hashtags: String?,
      video: String?,
      thumbnail: String?,
      images: String?,
      views: Long,
      likes: Long,
      comments: Long,
      saves: Long,
      shares: Long,
      isLiked: Long,
      isSaved: Long,
      isPinned: Long,
      canComment: Long,
      isTrending: Long,
      placeTitle: String?,
      placeLat: Double?,
      placeLon: Double?,
      state: String?,
      country: String?,
      musicId: Long?,
      createdAt: String,
      updatedAt: String,
    ) -> T,
  ): Query<T> = GetUserPostsQuery(userId, postType, value) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getString(18),
      cursor.getDouble(19),
      cursor.getDouble(20),
      cursor.getString(21),
      cursor.getString(22),
      cursor.getLong(23),
      cursor.getString(24)!!,
      cursor.getString(25)!!
    )
  }

  public fun getUserPosts(
    userId: Long,
    postType: Long,
    value_: Long,
  ): Query<PostEntity> = getUserPosts(userId, postType, value_) { id, postType_, userId_,
      description, hashtags, video, thumbnail, images, views, likes, comments, saves, shares,
      isLiked, isSaved, isPinned, canComment, isTrending, placeTitle, placeLat, placeLon, state,
      country, musicId, createdAt, updatedAt ->
    PostEntity(
      id,
      postType_,
      userId_,
      description,
      hashtags,
      video,
      thumbnail,
      images,
      views,
      likes,
      comments,
      saves,
      shares,
      isLiked,
      isSaved,
      isPinned,
      canComment,
      isTrending,
      placeTitle,
      placeLat,
      placeLon,
      state,
      country,
      musicId,
      createdAt,
      updatedAt
    )
  }

  public fun <T : Any> getAllPosts(mapper: (
    id: Long,
    postType: Long,
    userId: Long,
    description: String?,
    hashtags: String?,
    video: String?,
    thumbnail: String?,
    images: String?,
    views: Long,
    likes: Long,
    comments: Long,
    saves: Long,
    shares: Long,
    isLiked: Long,
    isSaved: Long,
    isPinned: Long,
    canComment: Long,
    isTrending: Long,
    placeTitle: String?,
    placeLat: Double?,
    placeLon: Double?,
    state: String?,
    country: String?,
    musicId: Long?,
    createdAt: String,
    updatedAt: String,
  ) -> T): Query<T> = Query(272_362_447, arrayOf("PostEntity"), driver, "Post.sq", "getAllPosts",
      "SELECT PostEntity.id, PostEntity.postType, PostEntity.userId, PostEntity.description, PostEntity.hashtags, PostEntity.video, PostEntity.thumbnail, PostEntity.images, PostEntity.views, PostEntity.likes, PostEntity.comments, PostEntity.saves, PostEntity.shares, PostEntity.isLiked, PostEntity.isSaved, PostEntity.isPinned, PostEntity.canComment, PostEntity.isTrending, PostEntity.placeTitle, PostEntity.placeLat, PostEntity.placeLon, PostEntity.state, PostEntity.country, PostEntity.musicId, PostEntity.createdAt, PostEntity.updatedAt FROM PostEntity ORDER BY createdAt DESC") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getString(18),
      cursor.getDouble(19),
      cursor.getDouble(20),
      cursor.getString(21),
      cursor.getString(22),
      cursor.getLong(23),
      cursor.getString(24)!!,
      cursor.getString(25)!!
    )
  }

  public fun getAllPosts(): Query<PostEntity> = getAllPosts { id, postType, userId, description,
      hashtags, video, thumbnail, images, views, likes, comments, saves, shares, isLiked, isSaved,
      isPinned, canComment, isTrending, placeTitle, placeLat, placeLon, state, country, musicId,
      createdAt, updatedAt ->
    PostEntity(
      id,
      postType,
      userId,
      description,
      hashtags,
      video,
      thumbnail,
      images,
      views,
      likes,
      comments,
      saves,
      shares,
      isLiked,
      isSaved,
      isPinned,
      canComment,
      isTrending,
      placeTitle,
      placeLat,
      placeLon,
      state,
      country,
      musicId,
      createdAt,
      updatedAt
    )
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertPost(PostEntity: PostEntity): QueryResult<Long> {
    val result = driver.execute(-950_863_246,
        """INSERT OR REPLACE INTO PostEntity (id, postType, userId, description, hashtags, video, thumbnail, images, views, likes, comments, saves, shares, isLiked, isSaved, isPinned, canComment, isTrending, placeTitle, placeLat, placeLon, state, country, musicId, createdAt, updatedAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)""",
        26) {
          bindLong(0, PostEntity.id)
          bindLong(1, PostEntity.postType)
          bindLong(2, PostEntity.userId)
          bindString(3, PostEntity.description)
          bindString(4, PostEntity.hashtags)
          bindString(5, PostEntity.video)
          bindString(6, PostEntity.thumbnail)
          bindString(7, PostEntity.images)
          bindLong(8, PostEntity.views)
          bindLong(9, PostEntity.likes)
          bindLong(10, PostEntity.comments)
          bindLong(11, PostEntity.saves)
          bindLong(12, PostEntity.shares)
          bindLong(13, PostEntity.isLiked)
          bindLong(14, PostEntity.isSaved)
          bindLong(15, PostEntity.isPinned)
          bindLong(16, PostEntity.canComment)
          bindLong(17, PostEntity.isTrending)
          bindString(18, PostEntity.placeTitle)
          bindDouble(19, PostEntity.placeLat)
          bindDouble(20, PostEntity.placeLon)
          bindString(21, PostEntity.state)
          bindString(22, PostEntity.country)
          bindLong(23, PostEntity.musicId)
          bindString(24, PostEntity.createdAt)
          bindString(25, PostEntity.updatedAt)
        }
    notifyQueries(-950_863_246) { emit ->
      emit("PostEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deletePost(id: Long): QueryResult<Long> {
    val result = driver.execute(-152_439_708, """DELETE FROM PostEntity WHERE id = ?""", 1) {
          bindLong(0, id)
        }
    notifyQueries(-152_439_708) { emit ->
      emit("PostEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun updatePostLike(
    isLiked: Long,
    likes: Long,
    id: Long,
  ): QueryResult<Long> {
    val result = driver.execute(2_091_973_433,
        """UPDATE PostEntity SET isLiked = ?, likes = ? WHERE id = ?""", 3) {
          bindLong(0, isLiked)
          bindLong(1, likes)
          bindLong(2, id)
        }
    notifyQueries(2_091_973_433) { emit ->
      emit("PostEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun updatePostSave(
    isSaved: Long,
    saves: Long,
    id: Long,
  ): QueryResult<Long> {
    val result = driver.execute(2_092_174_623,
        """UPDATE PostEntity SET isSaved = ?, saves = ? WHERE id = ?""", 3) {
          bindLong(0, isSaved)
          bindLong(1, saves)
          bindLong(2, id)
        }
    notifyQueries(2_092_174_623) { emit ->
      emit("PostEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteAllPosts(): QueryResult<Long> {
    val result = driver.execute(196_331_638, """DELETE FROM PostEntity""", 0)
    notifyQueries(196_331_638) { emit ->
      emit("PostEntity")
    }
    return result
  }

  private inner class GetPostByIdQuery<out T : Any>(
    public val id: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("PostEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("PostEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-755_427_921,
        """SELECT PostEntity.id, PostEntity.postType, PostEntity.userId, PostEntity.description, PostEntity.hashtags, PostEntity.video, PostEntity.thumbnail, PostEntity.images, PostEntity.views, PostEntity.likes, PostEntity.comments, PostEntity.saves, PostEntity.shares, PostEntity.isLiked, PostEntity.isSaved, PostEntity.isPinned, PostEntity.canComment, PostEntity.isTrending, PostEntity.placeTitle, PostEntity.placeLat, PostEntity.placeLon, PostEntity.state, PostEntity.country, PostEntity.musicId, PostEntity.createdAt, PostEntity.updatedAt FROM PostEntity WHERE id = ?""",
        mapper, 1) {
      bindLong(0, id)
    }

    override fun toString(): String = "Post.sq:getPostById"
  }

  private inner class GetPostsByTypeQuery<out T : Any>(
    public val postType: Long,
    public val `value`: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("PostEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("PostEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-317_187_161,
        """SELECT PostEntity.id, PostEntity.postType, PostEntity.userId, PostEntity.description, PostEntity.hashtags, PostEntity.video, PostEntity.thumbnail, PostEntity.images, PostEntity.views, PostEntity.likes, PostEntity.comments, PostEntity.saves, PostEntity.shares, PostEntity.isLiked, PostEntity.isSaved, PostEntity.isPinned, PostEntity.canComment, PostEntity.isTrending, PostEntity.placeTitle, PostEntity.placeLat, PostEntity.placeLon, PostEntity.state, PostEntity.country, PostEntity.musicId, PostEntity.createdAt, PostEntity.updatedAt FROM PostEntity WHERE postType = ? ORDER BY createdAt DESC LIMIT ?""",
        mapper, 2) {
      bindLong(0, postType)
      bindLong(1, value)
    }

    override fun toString(): String = "Post.sq:getPostsByType"
  }

  private inner class GetUserPostsQuery<out T : Any>(
    public val userId: Long,
    public val postType: Long,
    public val `value`: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("PostEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("PostEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(700_771_659,
        """SELECT PostEntity.id, PostEntity.postType, PostEntity.userId, PostEntity.description, PostEntity.hashtags, PostEntity.video, PostEntity.thumbnail, PostEntity.images, PostEntity.views, PostEntity.likes, PostEntity.comments, PostEntity.saves, PostEntity.shares, PostEntity.isLiked, PostEntity.isSaved, PostEntity.isPinned, PostEntity.canComment, PostEntity.isTrending, PostEntity.placeTitle, PostEntity.placeLat, PostEntity.placeLon, PostEntity.state, PostEntity.country, PostEntity.musicId, PostEntity.createdAt, PostEntity.updatedAt FROM PostEntity WHERE userId = ? AND postType = ? ORDER BY createdAt DESC LIMIT ?""",
        mapper, 3) {
      bindLong(0, userId)
      bindLong(1, postType)
      bindLong(2, value)
    }

    override fun toString(): String = "Post.sq:getUserPosts"
  }
}
